import React from "react"
import { Helmet } from "react-helmet"

const MenuSchema = ({ menuSchema }) => {
  return (
    <Helmet>
      {menuSchema && (
        <script type="application/ld+json">{JSON.stringify(menuSchema)}</script>
      )}
    </Helmet>
  )
}

export default MenuSchema
